
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';


const EVENTS = [
  {
    title: "Cribbage Tournament '26",
    subheader: "September 13, 2026",
    thumbnail: require("../assets/thumbnail_cribbage26.JPEG"),
    driveLink: "https://drive.google.com/drive/folders/1MnR73yJuj4uOmopBsrAbkTRWP5aeaVby?usp=share_link"
  },
  {
    title: "2026 San Pedro Festa",
    subheader: "June 27-28, 2026",
    thumbnail: require("../assets/thumbnail_festa_26.jpg"),
  
    driveLink: "https://drive.google.com/drive/folders/1cACMQwXAD2TFTmRxSnsvO4Ral3E_rnzX?usp=share_link"
  },
  {
    title: "2026 Easter Egg Hunt",
    subheader: "March 28, 2026",
    thumbnail: require("../assets/thumbnail_easter_26.JPG"),
    driveLink: "https://drive.google.com/drive/folders/14gmIs22lzuWTP-SsagsdeX56f8mxL9VZ?usp=share_link"
  },
  {
    title: "2025 Christmas Party",
    subheader: "December 13, 2025",
    thumbnail: require("../assets/Thumbnail_Christmas_25.JPG"),
    driveLink: "https://drive.google.com/drive/u/2/folders/1i66GRS-ps--bxyHW7hnbC_Emoj9D-k99"
  },{
    title: "2025 San Pedro Festa",
    subheader: "June 29, 2025",
    thumbnail: require("../assets/thumbnail_festa_25.JPG"),
    driveLink: "https://drive.google.com/drive/u/2/folders/1xFVZrsSGI_K4W9ZvSVmVhYnVAeNeR1Jw"
  },{
    title: "2024 San Pedro Festa",
    subheader: "June 30, 2024",
    thumbnail: require("../assets/SP-24_Thumbnail.JPG"),
    driveLink: "https://drive.google.com/drive/u/2/folders/1S2aErND1dS3NRkuillHw5mcZh53csfel"
  },{
    title: "2023 San Pedro Festa",
    subheader: "June 25, 2023",
    thumbnail: require("../assets/SP2301.jpg"),
    driveLink: "https://drive.google.com/drive/u/2/folders/1ACkM1fRU-XbOXqdEjT0kY3Olcb88G_Gr"
  },{
    title: "2022 San Pedro Festa",
    subheader: "June 26, 2022",
    thumbnail: require("../assets/SanPedro22_Thumbnail.jpg"),
    driveLink: "https://drive.google.com/drive/u/2/folders/1ghe_NeH3DF2xar6-L9Yjhri_sR4gjxio"
  },
  {
    title: "2019 San Pedro Festa",
    subheader: "June 30, 2019",
    thumbnail: require("../assets/thumbnail_festa_19.JPG"),
    driveLink: "https://drive.google.com/drive/folders/15EvRhCD0LaVdo2YBoMeLbC9JYYyv61_-?usp=share_link"
  },{
    title: "2015 San Pedro Festa",
    subheader: "June 27, 2015",
    thumbnail: require("../assets/SanPedro2015_Thumbnail.jpg"),
    driveLink: "https://drive.google.com/drive/u/2/folders/1xF8jgZr4hjLyKyqKbRzXTGYIWwNp9puX"
  },
  /*{
    title: "Portuguese in Yolo County",
    subheader: "April 26, 2015",
    thumbnail: require("../assets/Yolo2015_Thumbnail.jpg"),
    description: "Sponsored By San Pedro Association and arranged by SPA Historian Sharon Freitas. Photos by Member Robert Martinez",
  },
  {
    title: "Annual Easter Egg Hunt",
    subheader: "April 12, 2014",
    thumbnail: require("../assets/EasterEggHunt2014_Thumbnail.jpg"),
    description: "Prizes, Egg Toss (children/adults), Egg coloring, Hotdogs, Drinks, and more. A good time was had by all at San Pedro Park.",
  },*/
  {
    title: "2010 San Pedro Festa",
    subheader: "June 27, 2010",
    thumbnail: require("../assets/thumbnail_festa_2010.JPG"),
    driveLink: "https://drive.google.com/drive/folders/1IZM-o2QLayjUUEJ6nn0em8-gs9H211Yy?usp=share_link"
  },
  {
    title: "2009 San Pedro Festa",
    subheader: "June 28, 2009",
    thumbnail: require("../assets/thumbnail_festa_09.JPG"),
    driveLink: "https://drive.google.com/drive/folders/1UicVf4xHcj3oIvbtPEmUSyqAELWvXOgs?usp=share_link"
  },
  {
    title: "2008 San Pedro Festa",
    subheader: "June 29, 2008",
    thumbnail: require("../assets/thumbnail_festa_08.JPG"),
    driveLink: "https://drive.google.com/drive/folders/1XQpjbL6o8epqXdNbHUQ6vKsNOPwuANDO?usp=share_link"
  },
  {
    title: "1964 San Pedro Festa",
    subheader: "June 28, 1964",
    thumbnail: require("../assets/thumbnail_festa_64.JPG"),
    driveLink: "https://drive.google.com/drive/folders/1miEHkTMoCt7uCwiMwwPQAZu6n22qNwHz?usp=share_link"
  }
]

function EventCard({ event }) {
  return (
    <Card sx={{ width: "100%", height: "100%" }} elevation={4}>
      <CardHeader
        title={event.title}
        subheader={event.subheader}
        titleTypographyProps={{
          sx: {
            fontFamily: "'Cinzel', serif",
            fontWeight: 700,
          },
        }}
      />

      {event.thumbnail && (
        <CardMedia
          component="img"
          image={event.thumbnail}
          alt={event.title}
          sx={{
            width: "100%",
            height: { xs: 220, sm: 240 },
            objectFit: "cover",
            objectPosition: "center",
          }}
        />
      )}

      <CardContent>
        <Typography variant="body2" color="text.secondary">
          {event.description}
        </Typography>
      </CardContent>

      {event.driveLink && (
        <CardActions sx={{ justifyContent: "center" }}>
          <Button
            variant="outlined"
            href={event.driveLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            See more photos
          </Button>
        </CardActions>
      )}
    </Card>
  );
}

export default function PastEvents({ setModalUrl }) {
  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: 32,
      width: "100%"
    }}>
      {EVENTS.map(event => <EventCard key={event.title} event={event} />)}
    </div>
  )
}